import { Card } from "@blueprintjs/core";
import React from "react";

import { MultiSelectItem } from "../../../components/multi-select";
import { Team } from "../../../redux/slices";
import ConferenceTeams from "./conference-teams";
import { useGetGroupedLeagueTeams } from "./hooks/useGetTeams";
import { LoadingTeams } from "./loading-teams";
import styles from "./teams.tab.module.scss";

export interface LeagueTeamsProps {
  handleClickPlayCount: (item: MultiSelectItem) => void;
}

export const LeagueTeams = ({ handleClickPlayCount }: LeagueTeamsProps) => {
  const { groups, groupOrder, playCountMap, loading } = useGetGroupedLeagueTeams();

  if (loading)
    return (
      <Card className={styles.leagueTeamsCard}>
        <LoadingTeams />
      </Card>
    );

  return (
    <Card className={styles.leagueTeamsCard}>
      <div className={styles.teamsContainer}>
        {groupOrder.map((groupName, index) => (
          <ConferenceTeams
            key={index}
            conference={typeof groupName === "string" ? groupName : ""}
            teams={groups[groupName] as Team[]}
            handleClickPlayCount={handleClickPlayCount}
            playCountMap={playCountMap}
          />
        ))}
      </div>
    </Card>
  );
};

export default LeagueTeams;
